module.exports = __webpack_public_path__ + "static/media/41_B.cb724ba6.png";